import React from 'react';
import LegalLayout from '../LegalPage/LegalLayout';

const termsSections = [
    {
        heading: '1. Agreement to Terms',
        paragraphs: [
            'By accessing this website, booking an appointment, or receiving services from Dr. Eugene Pereira, MD (the “Clinic”), you agree to the following Terms and Conditions. If you do not agree, please discontinue use of our site and services.',
        ],
    },
    {
        heading: '2. Medical Disclaimer',
        paragraphs: [
            'Information on this website is provided for general education and should not be interpreted as medical advice. Diagnosis and treatment decisions are made only after a thorough consultation and examination by Dr. Pereira or a licensed member of the care team.',
        ],
        note: 'In an emergency, call 911 or visit the nearest emergency department.',
    },
    {
        heading: '3. Patient Responsibilities',
        paragraphs: [
            'To provide the highest level of care, we ask every patient to:'
        ],
        list: [
            'Share complete and accurate medical history, medications, allergies, and prior treatments.',
            'Inform the clinic promptly of changes to contact information, insurance coverage, or health status.',
            'Follow recommended treatment plans and post-procedure instructions.',
            'Respect staff and other patients by arriving on time and communicating with courtesy.',
        ],
    },
    {
        heading: '4. Appointment and Cancellation Policy',
        paragraphs: [
            'We reserve dedicated time for every consultation and procedure. If you need to cancel or reschedule, please notify us at least 24 hours in advance so we can offer the appointment to another patient in need.',
        ],
        note: 'Late cancellations or missed appointments may be subject to a fee. Surgical or procedural bookings may require additional notice and a deposit, which will be explained during scheduling.',
    },
    {
        heading: '5. Fees and Insurance',
        paragraphs: [
            'Fees for services are discussed during your consultation. Depending on your plan, certain services may qualify for insurance reimbursement. The clinic can assist with documentation, but you are responsible for confirming benefits and coordinating payment.',
        ],
        list: [
            'Payment is due at the time of service unless other arrangements are made in advance.',
            'Balances that remain unpaid may be referred to a billing partner for collection.',
            'We accept major credit cards, HSA/FSA accounts, and other forms of payment as communicated by our front office team.',
        ],
    },
    {
        heading: '6. Intellectual Property',
        paragraphs: [
            'All content on this website, including text, images, graphics, video, and logos, is owned or licensed by the clinic. You may view, download, or print content for personal reference only. Any reproduction or distribution without written permission is prohibited.',
        ],
    },
    {
        heading: '7. Limitation of Liability',
        paragraphs: [
            'While we strive to maintain accurate and up-to-date information, the clinic is not responsible for errors or omissions on this website. Use of the site and reliance on its content is at your own risk. In no event shall the clinic be liable for indirect, incidental, or consequential damages arising from site usage.',
        ],
    },
    {
        heading: '8. Changes to These Terms',
        paragraphs: [
            'We may update these Terms and Conditions to reflect changes in our services, legal requirements, or best practices. The revised date below will indicate the latest version. Continued use of the website or services constitutes acceptance of the updated terms.',
        ],
    },
    {
        heading: '9. Contact Information',
        paragraphs: [
            'If you have questions about these Terms or need assistance with your account, please reach out to our front desk team. We are here to help you navigate treatment options and policies with confidence.',
        ],
    },
];

const termsCta = {
    title: 'Need clarification on our policies?',
    description: 'Connect with our patient support team for billing questions, scheduling help, or a detailed explanation of any policy.',
    primary: { label: 'Contact the Clinic', to: '/contact' },
    secondary: { label: 'Return Home', to: '/' },
};

const TermsPage = () => (
    <LegalLayout
        title="Terms & Conditions"
        intro="These Terms and Conditions outline the policies that guide your relationship with Dr. Eugene Pereira, MD and the services provided through this clinic."
        sections={termsSections}
        lastReviewed="Nov 3, 2025"
        cta={termsCta}
    />
);

export default TermsPage;
